import * as React from 'react';

import { AddBlogPostForm } from '../../components/AddPostForm';
import { AddPostFormStub } from '../../AddPostFormStubs';
import { canSeeFormX } from './utils';

/**
 * Контейнер формы добавления/редактирования поста блога
 */
export const AddBlogPostFormContainer = () => {
  if (!canSeeFormX()) {
    return <AddPostFormStub />;
  }

  return <AddBlogPostForm title={''} />;
};
